import bugsnag from "@bugsnag/js";
import { FunctionComponent } from "react";
import { Section, Tile } from "@Types/pagify";
import "./style.scss";

export const SmallColoredIcons: FunctionComponent<{
  section: Section;
  tiles: Tile[];
}> = ({ section, tiles }) => {
  return (
    <div className="SmallColoredIcons">
      <h2 className="SmallColoredIcons-title">{section.title}</h2>
      <div className="SmallColoredIcons-wrapper">
        <div className="SmallColoredIcons-scroll">
          {tiles.map((tile) => {
            const title = tile.textBlock1 && tile.textBlock1[0].text;
            const tileImage = tile.images.length > 0 && tile.images[0].desktop;

            if (!tileImage) {
              bugsnag.notify(
                new Error(`image for tile ${tile.slug} not found in SmallColoredIcons`)
              );
            }

            return (
              <div className="SmallColoredIcons-item" key={tile.slug}>
                {!!tileImage && (
                  <img
                    alt={title || tile.slug}
                    className="SmallColoredIcons-item-image"
                    src={tileImage["1x"]}
                    srcSet={`${tileImage["1x"]} 1x, ${tileImage["2x"]} 2x`}
                  />
                )}
                <div
                  className="SmallColoredIcons-item-title"
                  style={{ backgroundColor: tile.backgroundColor?.hex }}
                >
                  {title}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
